module.exports = __webpack_public_path__ + "img/tcKgold.a87a923.png";